import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { RouterConfig } from './RouterConfig';
import { LanguageContextProvider } from './context/LanguageContextProvider';
import { MessageInfoContextProvider } from './context/MessageInfoContextProvider';
import { WindowSizeContextProvider } from './context/WindowSizeContextProvider';
import { DialogStateContextProvider } from './context/DialogStateContextProvider';
import { FliterContextProvider } from './context/FliterContextProvider';
import { TransitsContextProvider } from './context/TransitsContextProvider';
import { MasterContextProvider } from './context/MasterContextProvider';

// Contextが他のContextに依存するような場合、依存される側を外に書く必要がありそう
const App: React.FC = () => {
  return (
    // その他
    <ChakraProvider>
      {/* 他のContextに依存しないContext */}
      <WindowSizeContextProvider>
        <LanguageContextProvider>
          <FliterContextProvider>
            <MasterContextProvider>
              {/* 依存するContext */}
              <MessageInfoContextProvider>
                <DialogStateContextProvider>
                  <TransitsContextProvider>
                    {/* マスターデータ取得前の共通コンポーネント */}
                    <RouterConfig />
                    {/* ...マスターデータ取得前の共通コンポーネント */}
                  </TransitsContextProvider>
                </DialogStateContextProvider>
              </MessageInfoContextProvider>
              {/* ...依存するContext */}
            </MasterContextProvider>
          </FliterContextProvider>
        </LanguageContextProvider>
      </WindowSizeContextProvider>
      {/* ...依存しないContext */}
    </ChakraProvider>
    // ...その他
  );
};

export default React.memo(App);
